<template>
  <div class="anti-bullying-page">
    <!-- 顶部导航 -->
    <!-- <AppHeader /> -->

    <!-- 1. Banner 区域 (深色) -->
     <section class="ab-banner">
  <!-- 这里必须加上 class="container" -->
  <div class="bannercontainer"> 
    
    <!-- 左侧：文字与功能 -->
    <div class="banner-content">
      <h1>防霸凌预警系统</h1>
      
      <div class="sub-slogan">
        AI语音识别 · 主动预警 · 快速响应
      </div>
      
      <p class="main-desc">构建校园安全防护新范式</p>

      <!-- 功能列表 -->
      <div class="features-list">
        <!-- 功能1 -->
        <div class="feature-item">
          <div class="feature-icon">
            <!-- 图标颜色由 CSS 控制 -->
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
          </div>
          <div class="feature-text">
            <h4>AI语音识别</h4>
            <p>精准识别霸凌风险</p>
          </div>
        </div>
        <!-- 功能2 (建议换不同的图标，这里暂时复用) -->
        <div class="feature-item">
          <div class="feature-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
          </div>
          <div class="feature-text">
            <h4>敏感词预警</h4>
            <p>实时感知风险事件</p>
          </div>
        </div>
        <!-- 功能3 -->
        <div class="feature-item">
          <div class="feature-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
          </div>
          <div class="feature-text">
            <h4>一键紧急呼救</h4>
            <p>快速触发应急响应</p>
          </div>
        </div>
        <!-- 功能4 -->
        <div class="feature-item">
          <div class="feature-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
          </div>
          <div class="feature-text">
            <h4>安防联动响应</h4>
            <p>多系统协同处置</p>
          </div>
        </div>
      </div>
    </div>

    <!-- 右侧：视觉特效 (如果背景图里没有红圈，请取消注释) -->
    <!-- 
    <div class="banner-visual">
      <div class="alert-widget">
        <div class="alert-circle">
          <span class="alert-icon">!</span>
        </div>
        <div class="alert-label">检测到疑似霸凌</div>
      </div>
    </div> 
    -->
  </div>
</section>

    <!-- 2. 核心特点 (白色背景) -->
<!-- 2. 核心痛点 (白色背景) -->
<section class="ab-features">
  <div class="container">
    <!-- 修改标题区域 -->
    <div class="section-header">
      <h2>校园霸凌隐秘性强 传统手段难以及时发现</h2>
      <p class="section-subtitle">广校通防霸凌预警系统，运用AI技术与物联联动，打造校园安全的“主动防线”</p>
    </div>

    <div class="features-grid">
       <div class="feature-card" v-for="item in features" :key="item.id">
    <div class="icon-wrapper">
      <img :src="item.icon" :alt="item.title" class="icon-wrapper">
    </div>
    <h4>{{ item.title }}</h4>
    <p v-html="item.desc"></p>
  </div>
    </div>
  </div>
</section>

    <!-- 3. AI 预警监测 (深色背景) -->
   <!-- 3. AI 预警监测 (深色背景) -->
<section class="ab-monitor">
  <div class="container">
    <div class="monitor-layout">
      <div class="monitor-text">
        <h2>AI语音识别<br>精准感知风险</h2>
        <p class="desc">采用高精度语音识别与语义理解技术，7X24小时实时监测校园公共区域对话，识别潜在霸凌风险</p>
        <div class="stats-row">
          <div class="stat-item">
            <span class="num">98%<sup>+</sup></span>
            <span class="label">识别准确率</span>
          </div>
          <div class="stat-item">
            <span class="num">&lt;1<span class="unit">秒</span></span>
            <span class="label">预警响应时间</span>
          </div>
          <div class="stat-item">
            <span class="num">10<span class="unit">万+</span></span>
            <span class="label">敏感词库动态更新</span>
          </div>
        </div>
      </div>
      
      <!-- 右侧图片区域 -->
      <div class="monitor-visual">
        <!-- 请替换为您切好的真实图片地址 -->
        <img src="../assets/images/monitor-dashboard.png" alt="AI监测界面演示" class="dashboard-img">
      </div>
      
    </div>
  </div>
</section>

    <!-- 4. 一键紧急呼救 (浅色背景) -->
<!-- 4. 一键紧急呼救 (深色背景) -->
<section class="ab-sos">
  <div class="container">
    <div class="sos-layout">
      
      <!-- 左侧：设备图片 -->
      <div class="sos-device">
        <!-- 请替换为您的真实设备图片路径 -->
        <img src="../assets/images/sos-device.png" alt="紧急呼救按钮" class="device-img">
      </div>

      <!-- 右侧：文案与流程 -->
      <div class="sos-text">
        <h2>一键紧急呼救<br>快速响应，守护当下</h2>
        <p class="desc">遇到危险时，一键呼救，系统立即通知安保人员，并自动联动安防设备，第一时间介入处理。</p>
        
        <!-- 横向流程图 -->
        <div class="process-flow">
          <!-- 步骤1 -->
          <div class="flow-item">
            <div class="flow-icon">
               <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>
            </div>
            <h4>一键呼救</h4>
            <p>触发紧急报警</p>
          </div>
          
          <div class="flow-arrow">→</div>

          <!-- 步骤2 -->
          <div class="flow-item">
            <div class="flow-icon">
               <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
            </div>
            <h4>立即通知</h4>
            <p>安保/老师手机响</p>
          </div>

          <div class="flow-arrow">→</div>

          <!-- 步骤3 -->
          <div class="flow-item">
            <div class="flow-icon">
               <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg>
            </div>
            <h4>联动设备</h4>
            <p>开启声光威慑</p>
          </div>

          <div class="flow-arrow">→</div>

          <!-- 步骤4 -->
          <div class="flow-item">
            <div class="flow-icon">
               <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
            </div>
            <h4>快速到场</h4>
            <p>处置风险事件</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

   <!-- 5. 安防系统联动 (深色背景) -->
<section class="ab-linkage">
  <div class="container">
    <!-- 添加一个外层包裹，用于模拟图中的虚线大框 -->
    <div class="linkage-box">
      
      <!-- 左侧：文字 -->
      <div class="linkage-text">
        <h2>安防系统联动<br>构建立体防护</h2>
        <p>与视频监控、门禁、广播等系统联动，实现事件自动化处理，形成校园安全防护闭环。</p>
      </div>
      
      <!-- 右侧：联动示意图 (引入图片) -->
      <div class="linkage-visual">
        <!-- 请替换为您切好的右侧复杂拓扑图/建筑图 -->
        <img src="../assets/images/linkage-diagram.png" alt="安防联动示意图" class="diagram-img">
      </div>
      
    </div>
  </div>
</section>

<!-- 6. 硬件部署方案 (浅色背景) -->
<section class="ab-hardware">
  <div class="container">
    <div class="section-header">
      <h2>硬件部署方案 灵活适配各类校园场景</h2>
      <p class="subtitle">模块化设备涉及，支持多种部署方式，快速接入安防系统，覆盖重点区域，实现无死角守护</p>
    </div>
    
    <div class="hardware-grid">
      <!-- 卡片 1 -->
      <div class="hw-card">
        <div class="hw-img-box">
          <!-- 引入产品图 -->
          <img src="../assets/images/hw-mic.png" alt="AI语音识别终端">
        </div>
        <h4>AI语音识别终端</h4>
        <p>高灵敏度阵列麦克风<br>360°全向拾音</p>
      </div>
      
      <!-- 卡片 2 -->
      <div class="hw-card">
        <div class="hw-img-box">
          <img src="../assets/images/hw-sos.png" alt="紧急呼救终端">
        </div>
        <h4>紧急呼救终端</h4>
        <p>一键报警<br>防拆防水设计</p>
      </div>

      <!-- 卡片 3 -->
      <div class="hw-card">
        <div class="hw-img-box">
          <img src="../assets/images/hw-alarm.png" alt="声光警报器">
        </div>
        <h4>声光警报器</h4>
        <p>高分贝声光警示<br>有效威慑</p>
      </div>

      <!-- 卡片 4 -->
      <div class="hw-card">
        <div class="hw-img-box">
          <img src="../assets/images/hw-gateway.png" alt="边缘计算网关">
        </div>
        <h4>边缘计算网关</h4>
        <p>本地化部署<br>数据安全可控</p>
      </div>
    </div>
  </div>
</section>

    <!-- 底部 -->
    <AppFooter />

    <!-- 悬浮返回按钮 -->
    <button class="back-btn" @click="goBack">← 返回首页</button>
  </div>
</template>

<script>
// import AppHeader from './AppHeader.vue'
import AppFooter from './AppFooter.vue'

export default {
  name: 'AntiBullyingDetail',
  components: {AppFooter },
  data() {
    return {
      features: [
        { 
          id: 1, 
          title: '隐蔽性强', 
          desc: '霸凌多发生于隐蔽角落<br>难以被及时察觉',
          icon: require('@/assets/images/icon-hidden.png')
        },
        { 
          id: 2, 
          title: '取证困难', 
          desc: '缺乏有效证据<br>事后追溯难',
          icon: require('@/assets/images/icon-evidence.png')
        },
        { 
          id: 3, 
          title: '响应滞后', 
          desc: '人工发现晚<br>错过最佳干预时机',
          icon: require('@/assets/images/icon-response.png')
        },
        { 
          id: 4, 
          title: '管理被动', 
          desc: '缺乏智能化手段<br>难以主动预防',
          icon: require('@/assets/images/icon-management.png')
        }
      ],
      sosFeatures: ['防水防暴设计', '超长待机续航', '一键直连安保室', '录音录像留存证据'],
      hardwareList: [
        { id: 1, title: 'AI声纹采集器', desc: '隐蔽安装于厕所/走廊', name: '采集器' },
        { id: 2, title: '紧急求助按钮', desc: '安装于宿舍/角落', name: '按钮' },
        { id: 3, title: '声光报警器', desc: '安装于走廊/楼梯口', name: '报警器' },
        { id: 4, title: '边缘计算网关', desc: '本地数据处理中心', name: '网关' }
      ]
    }
  },
  methods: {
    goBack() {
      this.$emit('back')
    },
    contactUs() {
      alert('联系电话：020-82038386')
    }
  }
}
</script>

<style scoped>
/* 全局变量 */
.container { max-width: 1400px; margin: 0 auto; padding: 0 20px; }
.text-center { text-align: center; }

/* 1. Banner (深色) */
/* 1. 增加左侧渐变遮罩，让文字更清晰 */
.ab-banner {
  position: relative;
  width: 100%;
  min-height: 750px;
  /* 关键修改：增加 linear-gradient 遮罩，从左到右由深变透 */
  background: url('../assets/images/ab-banner.jpg'); 
  background-size: cover;
  background-position: center;
  color: #fff;
  display: flex;
  align-items: center;
  overflow: hidden;
}

/* 2. 补充 container 样式，控制内容宽度和位置 */
.ab-banner .bannercontainer {
  width: 1400px; /* 限制最大宽度 */
  margin: 0 auto; /* 居中 */
  padding: 0 20px;
  display: flex;
  justify-content: space-between; /* 左右分布 */
  align-items: center;
  position: relative;
  z-index: 2;
}

.banner-content {
  flex: 1;
  max-width: 700px; /* 稍微加宽一点容纳4个图标 */
}

.banner-content h1 {
  font-size: 52px; /* 稍微调小一点，避免换行 */
  font-weight: 800;
  margin-bottom: 20px;
  letter-spacing: 2px;
}

.sub-slogan {
  font-size: 22px;
  color: #e2e8f0; /* 稍微亮一点 */
  margin-bottom: 10px;
  font-weight: 500;
  /* 去掉 ::after 横线，因为图里没有 */
}

.main-desc {
  font-size: 18px;
  color: #94a3b8;
  margin-bottom: 60px; /* 增加底部间距，拉开与图标的距离 */
}

/* 3. 功能列表调整 */
.features-list {
  display: flex;
  gap: 30px; /* 增加间距 */
}

.feature-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  /* 去掉 max-width 限制，让文字自然排列 */
}

/* 4. 图标样式修正 (改为白色/浅灰) */
.feature-icon {
  width: 36px;
  height: 36px;
  background: rgba(255, 255, 255, 0.15); /* 背景稍微明显一点 */
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: #fff; /* 关键：图标颜色改为白色 */
}

.feature-icon svg {
  width: 20px;
  height: 20px;
  stroke: currentColor; /* 继承父级的白色 */
}

.feature-text h4 {
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 4px;
  color: #fff;
}

.feature-text p {
  font-size: 12px;
  color: #94a3b8;
  line-height: 1.4;
  white-space: nowrap; /* 防止文字换行 */
}

/* 5. 如果启用了右侧红圈，添加以下样式定位 */
.banner-visual {
  position: absolute;
  right: 10%;
  bottom: 15%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.alert-circle {
  width: 60px;
  height: 60px;
  background: rgba(239, 68, 68, 0.2);
  border: 2px solid #ef4444;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 20px rgba(239, 68, 68, 0.5);
  animation: pulse-red 2s infinite;
}

.alert-icon {
  color: #ef4444;
  font-size: 30px;
  font-weight: bold;
  font-style: normal;
}

.alert-label {
  margin-top: 10px;
  background: rgba(239, 68, 68, 0.9);
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  white-space: nowrap;
}

@keyframes pulse-red {
  0% { box-shadow: 0 0 0 0 rgba(239, 68, 68, 0.7); }
  70% { box-shadow: 0 0 0 15px rgba(239, 68, 68, 0); }
  100% { box-shadow: 0 0 0 0 rgba(239, 68, 68, 0); }
}
  
/* 2. Features (白色) */
/* 2. Features (白色背景) */
.ab-features { 
  padding: 80px 0; 
  background: #f6fafc; 
}

/* 标题区域居中 */
.section-header { 
  text-align: center; 
  margin-bottom: 60px; 
}

.section-header h2 { 
  color: #1e293b; 
  font-size: 32px; 
  font-weight: bold; 
  margin-bottom: 15px; 
  letter-spacing: 1px;
}

/* 副标题样式 */
.section-subtitle { 
  color: #64748b; 
  font-size: 14px; 
  max-width: 700px; 
  margin: 0 auto; 
  line-height: 1.6;
}

/* 网格布局 */
.features-grid { 
  display: grid; 
  grid-template-columns: repeat(4, 1fr); 
  gap: 24px; /* 稍微减小间距 */
}

/* 卡片样式 */
.feature-card { 
  background: #fff;
  text-align: center; 
  padding: 40px 20px; /* 增加上下内边距 */
  border: 1px solid #f1f5f9; /* 极淡的边框 */
  border-radius: 8px; 
  transition: all 0.3s ease;
}

/* 鼠标悬停效果：轻微上浮和阴影 */
.feature-card:hover { 
  box-shadow: 0 10px 40px rgba(0,0,0,0.08); 
  transform: translateY(-5px); 
  border-color: #e2e8f0;
}

/* 图标容器 */
.icon-wrapper {
  width: 64px;
  height: 64px;
  margin: 0 auto 25px;
  /* background: #f0f7ff; */
  /* border-radius: 50%; */
  display: flex;
  /* align-items: center; */
  justify-content: center;
}

/* 图标本身 */
.feature-icon {
  width: 28px;
  height: 28px;
  /* color: #3b82f6; */
}

.feature-card h4 { 
  margin-bottom: 15px; 
  color: #1e293b; 
  font-size: 18px;
  font-weight: 600;
}

.feature-card p { 
  font-size: 14px; 
  color: #64748b; 
  line-height: 1.6;
  margin: 0;
}

/* 响应式调整 */
@media (max-width: 992px) {
  .features-grid { grid-template-columns: repeat(2, 1fr); }
}
@media (max-width: 576px) {
  .features-grid { grid-template-columns: 1fr; }
}

/* 3. Monitor (深色) */
/* 3. Monitor (深色) */
.ab-monitor { 
  padding: 20px 0; 
  background: #050b14; /* 更深的背景色，贴近原图 */
  color: #fff; 
}

.monitor-layout { 
  display: flex; 
  align-items: center; 
  gap: 60px; 
}

.monitor-text { 
  flex: 1; 
  max-width: 450px; /* 限制左侧宽度 */
}

.monitor-text h2 { 
  font-size: 40px; 
  margin-bottom: 20px; 
  line-height: 1.3; 
  font-weight: bold;
}

.monitor-text .desc { 
  color: #94a3b8; 
  margin-bottom: 50px; 
  line-height: 1.6; 
  font-size: 15px;
}

/* 数据统计行 */
.stats-row { 
  display: flex; 
  gap: 40px; 
}

.stat-item { 
  display: flex; 
  flex-direction: column; 
}

.stat-item .num { 
  font-size: 36px; 
  font-weight: bold; 
  color: #3b82f6; 
  line-height: 1;
  margin-bottom: 10px;
}

.stat-item .num sup,
.stat-item .num .unit {
  font-size: 16px;
  font-weight: normal;
  margin-left: 2px;
}

.stat-item .label { 
  font-size: 13px; 
  color: #64748b; 
}

/* 右侧图片容器 */
.monitor-visual { 
  flex: 1.2; /* 右侧稍微宽一点 */
  position: relative;
}

.dashboard-img {
  width: 100%;
  height: auto;
  display: block;
  /* 如果图片本身没有虚线边框，可以在这里加一个模拟虚线框 */
  /* border: 1px dashed rgba(255,255,255,0.2); */
  border-radius: 8px;
  box-shadow: 0 20px 50px rgba(0,0,0,0.5); /* 增加一点阴影让图片更有质感 */
}

/* 响应式 */
@media (max-width: 992px) {
  .monitor-layout { flex-direction: column; }
  .monitor-text { max-width: 100%; margin-bottom: 40px; }
}
/* 4. SOS (浅色) */
/* 4. SOS (深色背景) */
.ab-sos { 
  padding: 20px 0; 
  background: #0b1120; /* 深色背景 */
  color: #fff; 
}

.sos-layout { 
  display: flex; 
  align-items: center; 
  gap: 60px; 
}

/* --- 左侧图片 --- */
.sos-device { 
  flex: 1; 
  display: flex; 
  justify-content: center; 
  align-items: center;
}

.device-img {
  max-width: 100%;
  height: auto;
  /* 如果图片本身没有阴影，可以加一个让它浮起来 */
  filter: drop-shadow(0 20px 40px rgba(0,0,0,0.5)); 
}

/* --- 右侧内容 --- */
.sos-text { 
  flex: 1; 
}

.sos-text h2 { 
  font-size: 36px; 
  margin-bottom: 20px; 
  line-height: 1.3;
  font-weight: bold;
}

.sos-text .desc { 
  color: #94a3b8; /* 浅灰色文字 */
  margin-bottom: 50px; 
  line-height: 1.6; 
  font-size: 15px;
  max-width: 90%;
}

/* --- 横向流程图 --- */
.process-flow {
  display: flex;
  align-items: center;
  gap: 15px; /* 元素间距 */
}

.flow-item {
  flex: 1;
  /* 1. 设置统一的最小高度，确保卡片一样高 */
  min-height: 160px; 
  /* 或者使用固定高度 height: 170px; */
  
  text-align: center;
  padding: 20px 2px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  transition: 0.3s;
  
  /* 2. 使用 Flex 布局让内容垂直居中 */
  display: flex;
  flex-direction: column;
  justify-content: center; /* 垂直居中 */
  align-items: center;     /* 水平居中 */
}

/* 可选：限制描述文字的行数或高度，防止个别文字太多 */
.flow-item p {
  font-size: 12px;
  color: #64748b;
  line-height: 1.4;
  margin: 0;
  /* 如果文字实在太多，可以限制最大行数，或者调整字号 */
}

.flow-item:hover {
  background: rgba(255, 255, 255, 0.08);
  border-color: #3b82f6;
}

.flow-icon {
  width: 40px;
  height: 40px;
  margin: 0 auto 15px;
  color: #3b82f6; /* 蓝色图标 */
}

.flow-icon svg {
  width: 100%;
  height: 100%;
}

.flow-item h4 {
  font-size: 16px;
  margin-bottom: 8px;
  color: #fff;
}

.flow-item p {
  font-size: 12px;
  color: #64748b;
  line-height: 1.4;
}

.flow-arrow {
  color: #334155;
  font-size: 20px;
  font-weight: bold;
  margin-top: -20px; /* 微调垂直位置 */
}

/* 响应式：手机端变为竖排 */
@media (max-width: 992px) {
  .sos-layout { flex-direction: column; }
  .process-flow { flex-direction: column; width: 100%; }
  .flow-arrow { transform: rotate(90deg); margin: 10px 0; }
  .sos-text { width: 100%; }
}

/* --- 5. Linkage (深色) --- */
.ab-linkage { 
  padding: 20px 0; 
  background: #050b14; /* 深色背景 */
  color: #fff; 
}

/* 模拟图中的大虚线框 */
.linkage-box {
  display: flex;
  border: 1px dashed rgba(255, 255, 255, 0.2); /* 整体虚线框 */
  border-radius: 8px;
  overflow: hidden;
  min-height: 400px;
}

/* 左侧文字区域 */
.linkage-text {
  flex: 0 0 40%; /* 占 40% 宽度 */
  padding: 60px 50px;
  border-right: 1px dashed rgba(255, 255, 255, 0.2); /* 中间分隔虚线 */
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.linkage-text h2 {
  font-size: 36px;
  margin-bottom: 20px;
  line-height: 1.3;
  font-weight: bold;
}

.linkage-text p {
  color: #94a3b8;
  font-size: 14px;
  line-height: 1.6;
}

/* 右侧图片区域 */
.linkage-visual {
  flex: 1;
  padding: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255,255,255,0.02); /* 稍微亮一点点的背景 */
}

.diagram-img {
  max-width: 100%;
  height: auto;
  /* 如果图片本身没有包含那四个角的图标，可能需要调整 */
  /* 这里假设您引入的是一张包含建筑+四个角图标的完整大图 */
}


/* --- 6. Hardware (浅色) --- */
.ab-hardware { 
  padding: 20px 0; 
  background: #fff; 
}

/* .section-header {
  text-align: center;
  margin-bottom: 60px;
}

.section-header h2 {
  font-size: 28px;
  color: #1e293b;
  margin-bottom: 15px;
  font-weight: bold;
} */

.section-header .subtitle {
  color: #64748b;
  font-size: 16px;
}

.hardware-grid { 
  display: grid; 
  grid-template-columns: repeat(4, 1fr); 
  gap: 24px; 
}

.hw-card { 
  background: #fff;
  padding: 30px 20px; 
  border-radius: 8px; 
  text-align: center; 
  /* 去掉原来的背景色，让虚线框更明显 */
}

/* 图片容器：模拟图中的虚线框 */
.hw-img-box {
  height: 160px;
  border: 1px dashed #cbd5e1; /* 浅灰色虚线 */
  border-radius: 8px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8fafc; /* 极淡的背景 */
  padding: 20px;
}

.hw-img-box img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.hw-card h4 { 
  margin-bottom: 10px; 
  color: #1e293b; 
  font-size: 16px;
}

.hw-card p { 
  font-size: 13px; 
  color: #64748b; 
  line-height: 1.5;
}

/* 响应式 */
@media (max-width: 992px) {
  .linkage-box { flex-direction: column; }
  .linkage-text { border-right: none; border-bottom: 1px dashed rgba(255,255,255,0.2); flex: auto; }
  .hardware-grid { grid-template-columns: repeat(2, 1fr); }
}

/* 返回按钮 */
.back-btn {
  position: fixed; bottom: 30px; right: 30px;
  background: #1e293b; color: #fff; border: none;
  padding: 15px 30px; border-radius: 30px;
  cursor: pointer; box-shadow: 0 5px 20px rgba(0,0,0,0.3);
  z-index: 1000; font-size: 16px;
}
.back-btn:hover { background: #334155; }
</style>